<template>
	<div v-if="baseData.length > 0">
		<base-card title="血压平均值（mmHg）" class="mt-28">
			<numberCard
				:list="[
                            {label:'收缩压（高压）',value:sbp,color:sbpColor},
                            {label:'舒张压（低压）',value:dbp,color:dbpColor}
                        ]"
			/>
			<textCard
				class="mt-40"
				:list="[
                            '根据医学指南：',
                            '一般高血压患者、高血压合并病情稳定的缺血性卒中患者血压目标值为＜140/90mmHg；',
                            '高血压合并出血性卒中患者、高血压合并有糖尿病患者血压目标值为＜130/80mmHg。',
                            '如有疑问，请咨询医生。',
                        ]"
			/>
		</base-card>
		<base-card title="血压趋势曲线" class="mt-28">
			<div class="char_drop_list">
				收缩压（高压）
				<span class="text-primary">•</span>
				舒张压（低压）
				<span style="color: #5285f4">•</span>
			</div>
			<IndicatorChart ref="chart" />
			<!-- <div class="echars-row" id="main"></div> -->
		</base-card>
		<base-card title="血压达标情况" class="mt-28">
			<div class="echars-row-two" id="mainPie"></div>
			<div class="number_card"
				>您本月血压测量天数为 <span>{{ detail.measureNumber }}</span> 天</div
			>
			<div class="number_card"
				>血压达标次数为 <span>{{ detail.pressureStandard }}</span> 次， 占总测量次数的比例为
				<span>{{ detail.pressureStandardScale }}</span> %</div
			>
		</base-card>
		<remind title="血压温馨提示" :list="tips" />
	</div>
	<van-empty
		v-else
		description="您本月记录的数据较少，无法为您做出分析和建议，建议您从今天开始，坚持测量血压并上传数据进行打卡，我们将在下月1日为您出具血压数据报告。"
	/>
</template>
<script>
import numberCard from './report-number-card.vue'
import textCard from './report-deatil-text.vue'
import remind from './report-detail-remind.vue'
import IndicatorChart from '../../indicator/components/indicator-chart.vue'
export default {
    name: 'reportPressure',
    components: { numberCard, textCard, remind, IndicatorChart },
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        baseData () {
            return this.detail.bloodPressureRecordList || []
        },
        patient () {
            return this.detail.patientDetail || {}
        },
        type () {
            return this.patient.pressurePersonType
        },
        sbp () {
            return this.detail.systolicPressure
        },
        dbp () {
            return this.detail.diastolicPressure
        },
        sbpColor () {
            let str = '#14C9C9'
            let base = 130
            if (this.type === 1) {
                base = 140
            }

            if (this.sbp > base) {
                str = '#FA5151'
            }
            return str
        },
        dbpColor () {
            let str = '#14C9C9'
            let base = 80
            if (this.type === 1) {
                base = 90
            }
            if (this.dbp > base) {
                str = '#FA5151'
            }
            return str
        },
        tips () {
            let str = [
                '1）保持血压在正常范围内需要长期坚持和努力。若您患有高血压并在服用降压药，请继续按时按量、规律用药；同时低盐低脂饮食、注意控制体重、适度运动、保持心理平衡。建议您坚持进行血压测量，以便知晓您的血压波动情况及控制情况。',
                '2）血压水平的个体差异比较大，请您遵医嘱合理控制血压。',
                '以上内容仅供参考，不作为诊疗依据。'
            ]
            let baseSbp = 130
            let baseDbp = 80
            if (this.type === 1) {
                baseSbp = 140
                baseDbp = 90
            }

            if ((this.sbp >= baseSbp) || (this.dbp >= baseDbp)) {
                str = [
                    '1）持续的血压升高会造成心、脑、肾、甚至全身血管损害，严重时会发生脑卒中、心肌梗死等危险。因此，建议您长期坚持健康生活方式：如低盐低脂饮食、注意控制体重、适度运动、保持心理平衡等，以平稳降压；若正在服用降压药治疗，还请遵医嘱按时按量、规律用药。同时建议您坚持进行血压测量，以便知晓您的血压波动情况及控制情况。',
                    '2）将血压降低到目标水平可以显著降低心脑血管疾病风险。根据医学指南，一般高血压患者建议血压目标值为＜140/90mmHg；对于高血压合并病情稳定的缺血性卒中患者，建议血压目标值为＜140/90mmHg；对于高血压合并出血性卒中患者，建议血压目标值为＜130/80mmHg；对于高血压合并有糖尿病患者，建议血压目标值为＜130/80mmHg。如有疑问，请咨询医生。',
                    '3）血压水平的个体差异比较大，请您遵医嘱合理控制血压。',
                    '以上内容仅供参考，不作为诊疗依据。'
                ]
            }
            return str
        }
    },
    methods: {
        init () {
            if (this.baseData.length === 0) {
                return
            }
            let time = []
            let sbp = []
            let dbp = []
            this.baseData.map(v => {
                time.push(this.$moment(v.measureTime).format('MM-DD'))
                sbp.push(v.highPressure)
                dbp.push(v.lowPressure)
            })

            this.$refs.chart.start({
                markArea: {
                    itemStyle: {
                        color: 'rgba(31, 35, 41, 0.1)'
                    },
                    data: []
                },
                datas: [
                    { name: '收缩压', color: '#4CBC84', data: sbp },
                    { name: '舒张压', color: '#5285F4', data: dbp }
                ],
                xAxis: time
            })
            // 使用刚指定的配置项和数据显示图表。
            this.initPie()
        },
        initPie () {
            let mainPie = this.$echarts.init(document.getElementById('mainPie'))

            window.addEventListener('resize', function () {
                mainPie.resize()
            })
            const { pressureStandard, bloodPressureRecordList } = this.detail
            let option = {
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} ({d}%)'
                },
                legend: {
                    show: false
                },
                series: [{
                    name: '',
                    type: 'pie',
                    radius: ['40%', '60%'],
                    avoidLabelOverlap: false,
                    stillShowZeroSum: false,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2,
                    },
                    label: {
                        alignTo: 'edge',
                        formatter: '{name|{b} {d}%}\n',
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 10,
                                color: '#999'
                            }
                        }
                    },

                    labelLine: {
                        length: 15,
                        length2: 0,
                        maxSurfaceAngle: 80
                    },
                    labelLayout: function (params) {
                        const isLeft = params.labelRect.x < mainPie.getWidth() / 2;
                        const points = params.labelLinePoints;
                        // Update the end point.
                        points[2][0] = isLeft
                            ? params.labelRect.x
                            : params.labelRect.x + params.labelRect.width;
                        return {
                            labelLinePoints: points
                        };
                    },
                    data: [
                        {
                            value: parseFloat(bloodPressureRecordList.length - pressureStandard), name: '未达标', itemStyle: {
                                color: '#F7BA1E'
                            }
                        },
                        {
                            value: pressureStandard, name: '达标', itemStyle: {
                                color: '#14C9C9'
                            }
                        },
                    ]
                }],
            }
            // 使用刚指定的配置项和数据显示图表。
            mainPie.setOption(option)
        }
    }
}
</script>
<style lang="less" scoped>
.number_card {
	font-size: 26px;
	color: #1f2329;
	vertical-align: bottom;
	text-align: center;
	span {
		font-size: 36px;
		color: @primary;
	}
}
.echars-row {
	width: 100%;
	height: 300px;
}
.echars-row-two {
	height: 360px;
	position: relative;
	overflow: hidden;
}
.char_drop_list {
	font-size: 24px;
	color: @gray-9;
	margin-bottom: 18px;
	padding-bottom: 26px;
	border-bottom: 1px solid #eeeeee;
	span {
		margin-right: 34px;
		margin-left: 10px;
	}
}
</style>